// 报告生成"待完成 / 已完成"状态机（sessionStorage，会话级，不跨标签）。
//
// 顶导气泡的生命周期：
//   1. 用户在等待页（GENERATING）-> markPending(type, id)
//      报告进 pending 桶，顶导不亮气泡（用户已经在看了）。
//   2. PageLayout 全局后台 polling 每 5s 检查 pending.* 里每个 id：
//      - 若 done -> markReady(type, id)，从 pending 挪到 ready，顶导亮气泡。
//   3. 用户在等待页等到 done（status DONE 在等待组件触发）-> markSeen(type, id)
//      用户已经看到 done 报告了，不该再弹气泡：从 pending 直接清掉，不挪到 ready。
//   4. 用户进 /history -> clearAll：整个 key 删掉，气泡归零。
//
// Schema:
//   {
//     pending:  { rough: ["73"], detailed: ["60"] },  // 等待中，后台 poll
//     ready:    { rough: ["72"], detailed: [] },      // 已 done 待用户看到
//   }

const KEY = 'aiq.pending_new_reports';
const EVENT = 'aiq:pending-changed';

function emptyState() {
  return { pending: { rough: [], detailed: [] }, ready: { rough: [], detailed: [] } };
}

function read() {
  try {
    const raw = JSON.parse(sessionStorage.getItem(KEY) || '{}');
    return {
      pending: {
        rough: Array.isArray(raw?.pending?.rough) ? raw.pending.rough : [],
        detailed: Array.isArray(raw?.pending?.detailed) ? raw.pending.detailed : [],
      },
      ready: {
        rough: Array.isArray(raw?.ready?.rough) ? raw.ready.rough : [],
        detailed: Array.isArray(raw?.ready?.detailed) ? raw.ready.detailed : [],
      },
    };
  } catch { return emptyState(); }
}

function write(state) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(state));
    window.dispatchEvent(new Event(EVENT));
  } catch { /* sessionStorage 不可用时静默 */ }
}

// type: 'rough' | 'detailed'
export function markPending(type, id) {
  if (!id || id === 'preview') return;
  const idStr = String(id);
  const s = read();
  if (s.pending[type].includes(idStr) || s.ready[type].includes(idStr)) return;
  s.pending[type] = [...s.pending[type], idStr];
  write(s);
}

// 用户在等待组件等到 done：从 pending 移除但不挪到 ready（不弹气泡）。
export function markSeen(type, id) {
  if (!id) return;
  const idStr = String(id);
  const s = read();
  const wasInPending = s.pending[type].includes(idStr);
  const wasInReady = s.ready[type].includes(idStr);
  if (!wasInPending && !wasInReady) return;
  s.pending[type] = s.pending[type].filter(x => x !== idStr);
  s.ready[type] = s.ready[type].filter(x => x !== idStr);
  write(s);
}

// 后台 polling 检测到 done：从 pending 挪到 ready（弹气泡）。
export function markReady(type, id) {
  if (!id) return;
  const idStr = String(id);
  const s = read();
  if (!s.pending[type].includes(idStr)) return;
  s.pending[type] = s.pending[type].filter(x => x !== idStr);
  if (!s.ready[type].includes(idStr)) {
    s.ready[type] = [...s.ready[type], idStr];
  }
  write(s);
}

export function readReadyCounts() {
  const s = read();
  return { rough: s.ready.rough.length, detailed: s.ready.detailed.length };
}

export function readPendingLists() {
  const s = read();
  return { rough: s.pending.rough, detailed: s.pending.detailed };
}

export function clearAll() {
  try {
    sessionStorage.removeItem(KEY);
    window.dispatchEvent(new Event(EVENT));
  } catch { /* ignore */ }
}

export const PENDING_EVENT = EVENT;
